module.exports = __webpack_public_path__ + "static/img/bear.452d5ad7.png";